import { EventGroup } from '../enumerations';
import {
  avaliahubApiUrl,
  handleAvaliahubOrDefaultUrl,
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import { requestJson } from '../http';
import {
  DetailProps,
  InstanceStatusProps,
  LoginLayoutProps,
  LoginParams,
  LoginProps,
} from './types';

export const login = ({
  email,
  password,
}: LoginParams): Promise<LoginProps> => {
  const myHeaders = myHeadersWithToken();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

  const urlencoded = new URLSearchParams();
  urlencoded.append('username', email);
  urlencoded.append('password', password);

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
  };

  const baseUrl = handleAvaliahubOrDefaultUrl();
  return fetch(`${baseUrl}/api/V1/login/control`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const getLoginLayout = (): Promise<LoginLayoutProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(EventGroup.BOOTSTRAP),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/login`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const logout = (): Promise<Partial<DetailProps>> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(EventGroup.LOGOUT),
  };

  const baseURL = handleAvaliahubOrDefaultUrl();
  return fetch(`${baseURL}/api/V1/logout`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

/** The instance status is only served by the avaliahub-api. */
export const isInstanceStatusEnabled = avaliahubApiUrl !== '';

/** Whether this instance may issue sessions right now (handshake and feed in sync). */
export const getInstanceStatus = (
  signal?: AbortSignal
): Promise<InstanceStatusProps> =>
  requestJson<InstanceStatusProps>(
    `${avaliahubApiUrl}/api/V1/instance/status`,
    { method: 'GET', headers: myHeadersWithToken(EventGroup.BOOTSTRAP) },
    signal
  );
